export default {
  language_selector: {
    label: 'Vælg et sprog',
  },
  nav_items: {
    home: 'Hjem',
    menu: 'Menu',
    locations: 'Lokationer',
    store_info: 'Butiksinfo',
    rewards: 'Belønninger',
  },
};
